import NProgress from 'nprogress'
import router from './router'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import store from './store'
import Cookies from 'js-cookie'

const whiteList = [
  '/',
  '/login/',
  '/join/',
  '/productList/',
  '/detail/:id/',
  '/guide/first',
  '/guide/seller',
  '/guide/vendor',
  '/info/agreement',
  '/info/privacy',
  '/info/responsibility',
  '/vendor/join',
  '/vendor/search'
] // 리다이렉션 제외 대상
router.beforeEach((to, from, next) => {
  NProgress.start()
  //상품 목록 페이지가 아닐때 퀵 검색 관련 쿠키 전부 삭제 및 최상단 검색어 삭제
  if (to.name !== 'productList') {
    Cookies.remove('PRODUCT_STATUS')
    Cookies.remove('PRODUCT_STATUS_VALUES')
    Cookies.remove('VAT_TYPE_VALUES')
    Cookies.remove('VAT_TYPE')
    Cookies.remove('DELIVERY_CHARGE_TYPE')
    Cookies.remove('DELIVERY_CHARGE_TYPE_VALUES')
    Cookies.remove('SALE_TYPE')
    Cookies.remove('SALE_TYPE_VALUES')
    Cookies.remove('IS_RETURNABLE')
    Cookies.remove('IS_RETURNABLE_VALUES')
    Cookies.remove('SELECTED_QUICK_SEARCH')
    Cookies.remove('QUICK_SEARCH_KEYWORD_VALUES')

    // 카테고리 값을 제외한 최상단 검색어 초기화
    const tempSearchParams = store.getters.searchParams
    tempSearchParams.text = ''
    store.dispatch('SEARCH_PARAMS', tempSearchParams)
  }

  // 상점 정보 (app.shopInfo)
  if (!store.getters.shopInfo) {
    store.dispatch('GetShopInfo').then(res => {})
  }

  if (getToken()) {
    //로그인여부

    //상품 목록 페이지에서 관심상품 조회 가능하도록 조건 추가
    if (to.name === 'productList') {
      store
        .dispatch('GetInfo')
        .then(res => {
          const userId = store.getters.userId
          store
            .dispatch('GetWishList', userId)
            .then(innerResponse => {
              next()
            })
            .catch(err => {
              store.dispatch('FedLogOut').then(() => {
                Message.error(err || 'Verification failed, please login again')
                next({ path: '/' })
              })
            })
          //next
        })
        .catch(err => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
    } else {
      /*this.$set(copyParams, 'text', '')
      this.$set(copyParams, 'categoryName', params.categoryName)
      this.$set(copyParams, 'subject', undefined)
      this.$store.dispatch('SEARCH_PARAMS', copyParams)*/
    }

    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (!store.getters.username) {
      store
        .dispatch('GetInfo')
        .then(res => {
          // 사용자정보 가져오기
          next()
        })
        .catch(err => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
    } else {
      next()
    }
  } else if (whiteList.indexOf(to.matched[1].path) !== -1) {
    next()
  } else {
    // 토큰이 없고 whiteList 없는 url 이면 로그인 메뉴로 로그인으로 보냄
    next('/login')
    NProgress.done()
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js